import React from 'react';
import {
  Container, Row, Card, CardBody, Table
} from 'reactstrap';
import Slider from 'react-slide-out';
import 'react-slide-out/lib/index.css';
import * as env from "../../../../env";
import { columnHeader } from "./config";
import Pagination from "../../../../shared/components/pagination/Pagination";
import FormComponent from "./form";
import MoreActions from "./MoreActions";
import { Link } from "react-router-dom";
import client from "../../../../shared/api-client";
import Modal from "../../../../shared/modal";

class ProxyTags extends React.Component {
  state = {
    title: 'Tags',
    addTitle: 'Add Tag',
    editTitle: 'Edit Tag',
    isOpen: false,
    results : [],
    filteredResults : [],
    columnHeader: columnHeader,
    filters: [],
    startIndex: 0,
    show: false,
    endIndex: env.RECORDS_PER_PAGE
  };

  showModal = e => {
    this.setState({
      show: !this.state.show
    });
  };

  getResults() {
    client(`tag.php`).then(
      (response) => {
        this.setResults(response);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  setResults = (results) => {
    this.setState({
      isOpen: false,
      results : results,
      filteredResults: results
    });
  }

  componentDidMount() {
    this.getResults();
  }

  handleForm = (formValues) => {
    this.setState({ formValues }, () => {
      // Validations will be added here if required frontend validations
    });
  };

  formChangeHandler = (event) => {
    let filters = this.state.filters;
    let filter = {'name' : event.target.name, 'value' : event.target.value};

    var foundIndex = filters.findIndex(x => x.name === filter.name);

    if (foundIndex >= 0) {
      filters[foundIndex] = filter;
    } else {
      filters.push(filter);
    }

    this.setState({filters});
    this.filterResults();
  }

  filterResults = () => {
    let filteredResults = this.state.results;

    this.state.filters.forEach((element, index) => {
      if (element.value.trim() !== '') {
        switch (element.name) {
          case 'id':
            filteredResults = filteredResults.filter(o =>
              Object.keys(o).some(k => String(o[element.name]).toLowerCase().includes(element.value.toLowerCase()))
            );
            break;
          default:
            filteredResults = filteredResults.filter(o =>
              Object.keys(o).some(k => o[element.name].toLowerCase().includes(element.value.toLowerCase()))
            );        
        } 
      }
    });
  
    
    this.setState({filteredResults});
  }

  printFilters = () => {
    return (<tr >
      {this.state.columnHeader.map(data => (data.filter) ? (<th key={data.key} > {this.printFilterInput(data)}</th>): (<th key={data.key} ></th>))}
    </tr>);
  }

  printFilterInput = (input) => {
    if (input.type === 'text')
        return (<input name={input.key} type="text" onChange={this.formChangeHandler}></input>);
    else if (input.type === 'list' || input.type === 'multiple-list')
        return (<select name={input.key} type="text" onChange={this.formChangeHandler}>
          <option value="">All</option>
          {this.printOptions(input.key)}
        </select>);
  }

  printOptions = (key) => {

    return <React.Fragment>
      {this.state.filterValues[key].map(value => ( <option value={value}>{value}</option> ))}
      
    </React.Fragment>
  };

  printRecords = () => {
    let items = this.state.filteredResults.slice(this.state.startIndex, this.state.endIndex + 1);

    return (<React.Fragment>
      {items.map(data => (
        <tr key={data.id}>
          {this.state.columnHeader.map((column) => 
            
            (column.key === 'actions') ? 
              (<td><MoreActions onEditClicked={() => (this.toggleEdit(data))}  item={data} /></td>) 
              : (column.key === 'users') ? (<td>
                <Link to={() => { return this.usersListingUrl(data)}} >
                  {data[column.key]}
                </Link>
              </td>) : (<td>{data[column.key]}</td>)
            )}
        </tr>
      ))}
    </React.Fragment>
  );
}

usersListingUrl = (tag) => {
  return `/proxy/tags/users/${tag.id}`
}

pagination = () => {
  return this.state.filteredResults.length > env.RECORDS_PER_PAGE ? (
    <div className="audit-trail-footer">
      <Pagination
        items={this.state.filteredResults}
        onChangePage={(pagination) => this.setState(pagination)}
        pageSize={env.RECORDS_PER_PAGE}
      />
    </div>
  ) : (
    ""
  )
}

toggleAddNew = () => {
  this.setState(prevState => ({ isOpen: !prevState.isOpen}));
}

toggleEdit = (editable) => {
  this.setState({editable});
  this.setState(prevState => ({ isOpen: !prevState.isOpen}));
}

submit = () => {
  let method = "PUT";

  if (this.state.editable !== undefined && this.state.editable.id !== undefined) {
    method = "POST";
  }

  client(`tag.php`, {
    method: method,
    body: this.state.formValues,
  }).then(
    (response) => {
      this.getResults();
      this.toggleAddNew();
    },
    (error) => {
      this.setState({
        show: true,
        errors: error._user_message,
        success: "",
      });
    }
  );
};

printActions = () => {
  return <React.Fragment>
    <button type="button" onClick={() => this.toggleAddNew()} className="btn btn-sm btn-primary">{this.state.addTitle}</button>
  </React.Fragment>
}

  render() {
    return (
      <Container>
        <Row className="user-section">
          <Card className="table-section form">
            <CardBody>
              <div className="card__title">
                <h5 className="bold-text">{this.state.title}</h5>
                <div className="toolbar-buttons">
                  {this.printActions()}
                </div>
              </div>
              <Table responsive hover className="table--head-accent table--bordered">
                <thead>
                  <tr>
                    {this.state.columnHeader.map(data => (<th key={data.key}>{data.name}</th>))}
                  </tr>
                  {this.printFilters()}
                </thead>
                <tbody >
                  {this.printRecords()}
                </tbody>
              </Table>
              {this.pagination()}
            </CardBody>
          </Card>
        </Row>
        <Slider
          isOpen={this.state.isOpen}
          footer={(
            <div className="button-container">
              <button className="square btn btn-primary btn-sm" onClick={() => this.submit()} type="button">Submit</button>
              <button type="button" className="square btn btn-danger btn-sm" onClick={() => this.toggleAddNew()}>
                Cancel
              </button>
            </div>
          )}
          onOutsideClick={() => this.setState({ isOpen: false })}
        >
          {<FormComponent  
            title={(this.state.editable !== undefined && this.state.editable.id !== undefined) ? this.state.editTitle : this.state.addTitle}
            handleForm={(formValues) => this.handleForm(formValues)} 
            toggleAddNew={this.toggleAddNew} 
            edit={() => {
              return this.state.editable;
            }} /> }
        </Slider>
        <Modal onClose={this.showModal} show={this.state.show} errors={this.state.errors}>
        </Modal>
      </Container>
    ); 
  }
}

export default ProxyTags;